import {
	GET_USERINFO,
	GET_PLACES,
	GET_TALENTS,
	GET_TRADE,
	GET_WRCODE,
	GET_LOCALS
} from './mutation-types.js'

export default {
	[GET_USERINFO](state, userInfo) {
		state.userInfo = userInfo;
	},
	[GET_PLACES](state, placeObj) {
		state.placeObj = placeObj;
	},
	[GET_TALENTS](state, talentArr) {
		state.talentArr = talentArr;
	},
	[GET_TRADE](state, tradeObj) {
		state.tradeObj = tradeObj;
	},
	[GET_WRCODE](state,qrcode){
		state.qrcode = qrcode;
	},
	[GET_LOCALS](state, localObj) {
		state.localObj = localObj;
	}
}



// WEBPACK FOOTER //
// ./src/store/mutations.js